export default {"src":"/trader-new/_next/static/media/call.3fb706a8.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};